export const iconFontAwesomeDesignCropSimple = (
	<i className="fa-solid fa-crop-simple"></i>
);
